module.exports = __webpack_public_path__ + "static/media/stellar-logo.5cfc2c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stellar-logo.png
// module id = 1647
// module chunks = 0